import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "lc_btn_sure_icon",
  "use": "lc_btn_sure_icon-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"lc_btn_sure_icon\"><defs><style type=\"text/css\"></style></defs><path d=\"M950.5 225.5c-11.5-11.5-28.7-11.5-40.2 0L399.6 736.2l-286.9-287c-11.5-11.5-28.7-11.5-40.2 0s-11.5 28.7 0 40.2l309.9 309.9s17.2 17.2 40.2 0l533.7-533.7c5.7-11.5 5.7-28.7-5.8-40.1z\" p-id=\"1960\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol